import { render, staticRenderFns } from "./EditBonusModal.vue?vue&type=template&id=804d2fba&"
import script from "./EditBonusModal.vue?vue&type=script&lang=js&"
export * from "./EditBonusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports